import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { clickStreamUser } from "../../../../utils/AppUtils";
import SubscriptionPriceSectionComponent from "../../SubscriptionPage/SubscriptionPriceSection/SubscriptionPriceSectionComponent";
import TestimonialComponent from "../../Testimonial/TestimonialComponent";
import XselAdvantagePanelComponent from "../XselAdvantagePanel/XselAdvantagePanelComponent";
import "./GuestHomePageComponent.scss";
import "./BelowBanner.scss";
import FreeVideos from "../../UsefulEntity/FreeVideos";
import PopularFreeCourses from "../../UsefulEntity/PopularFreeCourses";
import PopularCertifications from "../../UsefulEntity/PopularCertifications";
import VideoPlayer from "react-video-js-player";
import RecommendationEnginePage from "../../../../pages/B2C-Pages/RecommendationEnginePage";
import SubscriptionPricing from "../../../b2cComponents/homepage/SubscriptionPricing";
import BannerSection from "../../../BannerSection";
import Slider from "react-slick";
import { useDispatch, useSelector } from "react-redux";
import { getActiveHeader } from "../../../../redux/home/actions";
import { getGuestBanners } from "../../../../redux/user/actions";
import _ from "lodash";
const GuestHomePageComponent = (props) => {
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [bannerData, setBannerData] = useState("");
  const bannerDataRes = useSelector((state) => state.user.guestBannerData);
  let dispatch = useDispatch();

  useEffect(() => {
    setTimeout(() => {
      dispatch(getActiveHeader("home"));
    }, 1000);
  }, []);
  const redirectToSignUp = () => {
    clickStreamUser("clicked-login-btn", {
      is_guest_user: true,
      session_id: localStorage.getItem("sessionId"),
    });
    navigate("/sign-up?p=1");
  };
  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        //style={{ ...style, display: "block"}}
        onClick={onClick}
      >
        <svg class="flickity-button-icon" viewBox="0 0 100 100">
          <path
            d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z"
            class="arrow"
            transform="translate(100, 100) rotate(180) "
          ></path>
        </svg>
      </div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        //style={{ ...style, display: "block"}}
        onClick={onClick}
      >
        <svg class="flickity-button-icon" viewBox="0 0 100 100">
          <path
            d="M 10,50 L 60,100 L 60,95 L 15,50  L 60,5 L 60,0 Z"
            class="arrow"
          ></path>
        </svg>
      </div>
    );
  }
  var settings = {
    dots: true,
    infinite: true,
    speed: 1000,
    autoplay: true,
    autoplaySpeed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
  };

  useEffect(() => {
    getBannersApi();
  }, []);
  const getBannersApi = () => {
    dispatch(
      getGuestBanners({
        module: "guestBanners",
        postData: {
          entity_type: "home-banner",
        },
      })
    );
  };

  useEffect(() => {
    if (!_.isEmpty(bannerDataRes)) {
      if (bannerDataRes?.status === "success") {
        console.log("banner data--", bannerDataRes);
        let data = bannerDataRes?.payload?.payload;
        setBannerData(data);
        setIsLoading(false);
      } else {
        setBannerData([]);
        setIsLoading(false);
      }
    }
  }, [bannerDataRes]);

  const renderBanner = () => {
    return (
      <Slider {...settings} className="bannerslider-guest">
        <section className="bannersection-home">
          <div className="container-fluid mob-rev p-0">
            <div className="col-lg-6 col-12 leftsec">
              <h1>Welcome to Xsel - Your Gateway to Real Estate Excellence!</h1>
              <div className="discription-jhome-abner">
              <p>
                Xsel isn’t just a learning platform—it's an innovative,
                AI-powered tool designed to transform your real estate career.
              </p>
              <p>
                Whether you’re a seasoned agent or just starting out, Xsel
                provides the resources and support you need to thrive in today’s
                competitive market. Join thousands of agents who have already
                made Xsel their go-to platform for professional development.
              </p>
              </div>
              <button
                type="button"
                className="default-btn"
                onClick={() => redirectToSignUp()}
              >
                Subscribe free today
              </button>
            </div>
            <div
              className="col-lg-6 col-12 rightsec"
              style={{ background: "url" }}
            ></div>
          </div>
        </section>
        {!_.isEmpty(bannerData)
          ? bannerData.map((m, index) => {
              return (
                // <section className="container-fluid p-0" key={index}>
                //   <div className="row">
                //     <section className="baner-section home_page_bannner">
                //       <div className="row m-0">
                //         <div className=" p-0 carousel_slide">
                //           <div
                //             id="carouselExampleIndicators"
                //             className="carousel slide"
                //             data-bs-ride="carousel"
                //           >
                //             <div className="carousel-inner">
                //               <div className="carousel-item active dynamic-banner">
                //                 <img
                //                   src={m.thumbnail}
                //                   className="d-block w-100"
                //                   alt="..."
                //                 />
                //                 <div className="provider-slider-inner">
                //                   <div className="container">
                //                     <div className="banner-text-provider text-white">
                //                       {m?.banner_title_visibility === "1" && (
                //                         <h2 className="mainHEADING">
                //                           {m.banner_title}
                //                         </h2>
                //                       )}

                //                       <div className=" d-flex py-3">
                //                         <a
                //                           href={m.button_url}
                //                           target="_blank"
                //                           rel="noopener noreferrer"
                //                         >
                //                           {m.button_text === undefined ||
                //                           _.isEmpty(m.button_text) ? (
                //                             ""
                //                           ) : (
                //                             <button
                //                               type="button"
                //                               className="startcourse-btn"
                //                               onClick={() => {
                //                                 clickStreamUser(
                //                                   "more-info-button-clicked",
                //                                   {
                //                                     url: m.button_url,

                //                                   }
                //                                 );
                //                               }}
                //                             >
                //                               {m.button_text}
                //                               <svg
                //                                 xmlns="http://www.w3.org/2000/svg"
                //                                 width="20"
                //                                 height="20"
                //                                 viewBox="0 0 20 20"
                //                                 fill="none"
                //                               >
                //                                 <path
                //                                   d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                //                                   stroke="#6941C6"
                //                                   strokeWidth="1.66667"
                //                                   stroke-linecap="round"
                //                                   stroke-linejoin="round"
                //                                 ></path>
                //                               </svg>
                //                             </button>
                //                           )}
                //                         </a>
                //                       </div>
                //                     </div>
                //                   </div>
                //                 </div>
                //               </div>
                //             </div>
                //           </div>
                //         </div>
                //       </div>
                //     </section>
                //   </div>
                // </section>
                <section className="bannersection-home">
                  <div className="container-fluid mob-rev p-0">
                    <div className="col-lg-6 col-12 leftsec">
                      <h1>{m?.title}</h1>

                      <div className="discription-jhome-abner"
                        dangerouslySetInnerHTML={{
                          __html: m?.description,
                        }}
                      ></div>
                      {m?.button_text ? (
                        <button
                          type="button"
                          className="default-btn"
                          onClick={() => window.open(m?.button_url, "_blank")}
                        >
                          {m?.button_text}
                        </button>
                      ) : (
                        " "
                      )}
                    </div>
                    <div
                      className="col-lg-6 col-12 rightsec"
                      style={{ backgroundImage: `url(${m?.thumbnail})` }}
                    ></div>
                  </div>
                </section>
              );
            })
          : ""}
      </Slider>
    );
  };

  const onPlayerReady = (player) => {
    player.src("");
    // let videoData = videoDetailInfo[0];
    // player.src({
    //   src: videoData.video_link,
    //   withCredentials: true,
    // });
    const trackEl = player.addRemoteTextTrack(
      {
        // src: videoData?.subtitle_url,
        kind: "captions",
        srclang: "en",
        label: "English",
      },
      false
    );
    trackEl.addEventListener("load", function () {});
    window.scrollTo(0, 50);
  };

  const renderGetStartedSection = () => {
    return (
      <section className="belowbanner">
        <div className="container text-center">
          <h2 htmlFor="">Jump start your career today—free!</h2>
          <p>
            Register with Xsel to get access to comprehensive training courses,
            expert insights, and invaluable career resources—all at no cost to
            you. Whether you're a beginner or a seasoned pro, our free
            subscription is your passport to learning and growing in the real
            estate industry.
          </p>
          <p>
            <b>Don't miss out on this opportunity:</b> Sign up now and unlock
            your future in real estate—no strings attached!
          </p>

          <button
            className="subscriptionbtn"
            onClick={() => redirectToSignUp()}
          >
            Get your free subscription
          </button>
          <div className="vieosec">
            {/* <iframe
              className="w-100"
              src={"https://www.youtube.com/embed/p4J-MbXOaqE"}
              title={"Real Estate Video"}
              height="100%"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              width="100%"
            /> */}
            <VideoPlayer
              className="img-videosec-home learn_image-card"
              controls={true}
              src={
                "https://rsplearning-dev.niit-mts.com/meeting/images/617527938043218.mp4"
              }
              width="100%"
              height="516"
              autoPictureInPicture={true}
              // poster={!showLearnMore ? item?.product_thumbnail : ""}
              fluid={true}
              inline={false}
              pictureInPictureToggle={true}
              type={"video/mp4"}
              onReady={onPlayerReady}
              crossorigin="use-credentials"
            />
          </div>
        </div>
      </section>
    );
  };
  return (
    <>
      {/* <BannerSection isLoading={isLoading} setIsLoading={setIsLoading} /> */}
      {renderBanner()}
      <section className="faq-section why-xseldec pt-5 pb-5">
        <div className="container">
          <div className="row">
            <div className="col-12 mb-3">
              <div className="faq-heading">
                Why <strong>Xsel</strong>
              </div>
              {/* <div className="faq-sub-head">Everything you need to know about the product and billing.</div> */}
            </div>
          </div>
          <div className="row gy-5">
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    ></rect>
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      stroke-width="8"
                    ></rect>
                    <g transform="translate(45, 45) scale(1)">
                      <path
                        d="M-7.2866 -19.8719L-7.5332 -19.3062C-7.7136 -18.8921 -8.2864 -18.8921 -8.4669 -19.3062L-8.7134 -19.8719C-9.1529 -20.8805 -9.9445 -21.6836 -10.9323 -22.1229L-11.692 -22.4608C-12.1027 -22.6435 -12.1027 -23.2412 -11.692 -23.4239L-10.9748 -23.7429C-9.9616 -24.1935 -9.1558 -25.0263 -8.7239 -26.0692L-8.4707 -26.6805C-8.2942 -27.1065 -7.7058 -27.1065 -7.5294 -26.6805L-7.2762 -26.0692C-6.8442 -25.0263 -6.0384 -24.1935 -5.0252 -23.7429L-4.3081 -23.4239C-3.8973 -23.2412 -3.8973 -22.6435 -4.3081 -22.4608L-5.0677 -22.1229C-6.0555 -21.6836 -6.8471 -20.8805 -7.2866 -19.8719ZM-18 -25H-14V-23H-18C-21.3137 -23 -24 -20.3137 -24 -17C-24 -13.39 -21.5379 -11.0344 -16 -8.5202V-11H-14C-10.6863 -11 -8 -13.6863 -8 -17H-6C-6 -12.5817 -9.5817 -9 -14 -9V-5.5C-19 -7.5 -26 -10.5 -26 -17C-26 -21.4183 -22.4183 -25 -18 -25Z"
                        clip-rule="evenodd"
                      ></path>
                    </g>
                  </svg>
                </div>
                <div className="faq-question">Advanced AI Integration</div>
                <div className="faq-answer">
                  Xsel integrates advanced AI technology into real estate
                  learning, offering personalized, flexible, and interactive
                  training experiences. Tailored to meet the needs of real
                  estate professionals, our platform adapts to your pace and
                  learning style for maximum impact.
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    ></rect>
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      stroke-width="8"
                    ></rect>
                    <g transform="translate(15, 15) scale(1)">
                      <path d="M20.7134 7.12811L20.4668 7.69379C20.2864 8.10792 19.7136 8.10792 19.5331 7.69379L19.2866 7.12811C18.8471 6.11947 18.0555 5.31641 17.0677 4.87708L16.308 4.53922C15.8973 4.35653 15.8973 3.75881 16.308 3.57612L17.0252 3.25714C18.0384 2.80651 18.8442 1.97373 19.2761 0.930828L19.5293 0.319534C19.7058 -0.106511 20.2942 -0.106511 20.4706 0.319534L20.7238 0.930828C21.1558 1.97373 21.9616 2.80651 22.9748 3.25714L23.6919 3.57612C24.1027 3.75881 24.1027 4.35653 23.6919 4.53922L22.9323 4.87708C21.9445 5.31641 21.1529 6.11947 20.7134 7.12811ZM9 2C13.0675 2 16.426 5.03562 16.9337 8.96494L19.1842 12.5037C19.3324 12.7367 19.3025 13.0847 18.9593 13.2317L17 14.071V17C17 18.1046 16.1046 19 15 19H13.001L13 22H4L4.00025 18.3061C4.00033 17.1252 3.56351 16.0087 2.7555 15.0011C1.65707 13.6313 1 11.8924 1 10C1 5.58172 4.58172 2 9 2ZM9 4C5.68629 4 3 6.68629 3 10C3 11.3849 3.46818 12.6929 4.31578 13.7499C5.40965 15.114 6.00036 16.6672 6.00025 18.3063L6.00013 20H11.0007L11.0017 17H15V12.7519L16.5497 12.0881L15.0072 9.66262L14.9501 9.22118C14.5665 6.25141 12.0243 4 9 4ZM19.4893 16.9929L21.1535 18.1024C22.32 16.3562 23 14.2576 23 12.0001C23 11.317 22.9378 10.6486 22.8186 10L20.8756 10.5C20.9574 10.9878 21 11.489 21 12.0001C21 13.8471 20.4436 15.5642 19.4893 16.9929Z"></path>
                    </g>
                  </svg>
                </div>
                <div className="faq-question">Agent-Centric Design</div>
                <div className="faq-answer">
                  With an agent-first approach, Xsel ensures every feature,
                  tool, and resource is designed with agents in mind. From
                  role-playing simulations to real-world scenarios, Xsel
                  supports your success in today’s fast-paced real estate
                  market.
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    ></rect>
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      stroke-width="8"
                    ></rect>
                    <g transform="translate(15, 15) scale(1)">
                      <path d="M20.7134 8.12811L20.4668 8.69379C20.2864 9.10792 19.7136 9.10792 19.5331 8.69379L19.2866 8.12811C18.8471 7.11947 18.0555 6.31641 17.0677 5.87708L16.308 5.53922C15.8973 5.35653 15.8973 4.75881 16.308 4.57612L17.0252 4.25714C18.0384 3.80651 18.8442 2.97373 19.2761 1.93083L19.5293 1.31953C19.7058 0.893489 20.2942 0.893489 20.4706 1.31953L20.7238 1.93083C21.1558 2.97373 21.9616 3.80651 22.9748 4.25714L23.6919 4.57612C24.1027 4.75881 24.1027 5.35653 23.6919 5.53922L22.9323 5.87708C21.9445 6.31641 21.1529 7.11947 20.7134 8.12811ZM12 2C6.47715 2 2 6.47715 2 12C2 13.7025 2.42544 15.3056 3.17581 16.7088L2 22L7.29117 20.8242C8.6944 21.5746 10.2975 22 12 22C17.5228 22 22 17.5228 22 12C22 11.5975 21.9762 11.2002 21.9298 10.8094L19.9437 11.0452C19.9809 11.3579 20 11.6765 20 12C20 16.4183 16.4183 20 12 20C10.6655 20 9.38248 19.6745 8.23428 19.0605L7.58075 18.711L4.63416 19.3658L5.28896 16.4192L4.93949 15.7657C4.32549 14.6175 4 13.3345 4 12C4 7.58172 7.58172 4 12 4C12.6919 4 13.3618 4.0876 14 4.25179L14.4983 2.31487C13.6987 2.10914 12.8614 2 12 2ZM9 12H7C7 14.7614 9.23858 17 12 17C14.7614 17 17 14.7614 17 12H15C15 13.6569 13.6569 15 12 15C10.3431 15 9 13.6569 9 12Z"></path>
                    </g>
                  </svg>
                </div>
                <div className="faq-question">Large User Base</div>
                <div className="faq-answer">
                  Join thousands of agents already leveraging Xsel as their
                  trusted professional development solution. Our platform is
                  built for real estate agents like you, powered by advanced AI
                  and proven to drive results.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <TestimonialComponent />
      <XselAdvantagePanelComponent />
      <SubscriptionPricing />
      <SubscriptionPriceSectionComponent {...props} />
      <PopularCertifications />
      <FreeVideos />
     {false && <PopularFreeCourses />}
      {false && renderGetStartedSection()}
      <RecommendationEnginePage />
    </>
  );
};

export default GuestHomePageComponent;
